window.addEventListener("scroll", () => {
  const hero = document.querySelector(".hero-anim");
  const logo = document.querySelector(".hero-logo img");
  if (!hero) return;

  const y = window.scrollY;
  const leftImg = hero.querySelector(".split-showcase__image--left img");
  const rightImg = hero.querySelector(".split-showcase__image--right img");

  if (leftImg && rightImg) {
    leftImg.style.transform = `translate(-${y * 0.25}px, -${y * 0.1}px) rotate(-${y * 0.02}deg)`;
    rightImg.style.transform = `translate(${y * 0.25}px, -${y * 0.1}px) rotate(${y * 0.02}deg)`;
  }

  if (logo) {
    if (y > 200 && y < 600) {
      logo.style.transform = `translate(-50%, -50%) scale(1) rotate(${y}deg)`;
      logo.style.opacity = "1";
    } else if (y < 200) {
      logo.style.transform = `translate(-50%, -50%) scale(0) rotate(0deg)`;
      logo.style.opacity = "0";
    }
  }
});
